import { createAction } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import { Country } from '../../models/country';

export const GET_COUNTRIES = '[Dictionary] Get countries';
export const GET_COUNTRIES_SUCCESS = '[Dictionary] Get countries success';
export const GET_COUNTRIES_FAIL = '[Dictionary] Get countries fail';
export const SET_COUNTRIES_LOADING = '[Dictionary] Set countries loading';

export const GetCountries = createAction(GET_COUNTRIES, (isForce?: boolean) => ({ isForce: isForce || false }));
export const GetCountriesSuccess = createAction(GET_COUNTRIES_SUCCESS, (countries: Country[]) => ({ countries }));
export const GetCountriesFail = createAction(GET_COUNTRIES_FAIL, (err: HttpErrorResponse) => ({ err }));

export const SetCountriesLoading = createAction(SET_COUNTRIES_LOADING);
